
import { useUser } from '@/mixins'
import { Message } from '@/models/message'
import dayjs from 'dayjs'
import { computed, defineComponent, PropType } from 'vue'
export default defineComponent({
  props: {
    message: {
      type: Object as PropType<Message>,
      default: () => null
    }
  },
  setup(props) {
    const { currentUser } = useUser()

    const sender = computed(() => {
      return currentUser.value.id == props.message.senderId
    })

    const formatDate = (date: number): string => {
      return dayjs(date).format('hh:mm a')
    }
    return {
      sender,
      formatDate,
      currentUser
    }
  }
})
